'use client';

import { NavbarBrand } from '@/components/molecules';

import { FooterLinks } from './FooterLinks';

import type { Page } from '@/lib/api/types';

export interface FooterProps {
  pages: Page[];
  logo: string;
  name: string;
}

export const Footer = ({ pages, logo, name }: FooterProps) => {
  const visiblePages = pages.filter(
    page => page.footer.displayed && !page.is_signup,
  );

  return (
    <footer className="w-full border-t border-b border-(--color-border-neutral-softer-3) bg-(--color-surface-default) py-(--vertical-spacing-3) px-(--horizontal-spacing-6) gap-4">
      <div className="flex flex-wrap items-start gap-(--horizontal-spacing-4) justify-between">
        <NavbarBrand artwork={logo} name={name} />
        <div className="flex flex-wrap gap-(--horizontal-spacing-2) w-auto">
          <FooterLinks pages={visiblePages} />
        </div>
      </div>
    </footer>
  );
};
